export default "__VITE_ASSET__BpG5dc67__"